import * as orderStatuses from '@/constants/orderStatuses';
import * as courierStatuses from '@/constants/courierStatuses';

const courierStatusOrder = {
    [courierStatuses.AVAILABLE]: 1,
    [courierStatuses.SERVICING]: 2,
    [courierStatuses.OFF_DUTY]: 3
};

export default {
    getOrderStatusColor(status) {
        switch (status) {
            case orderStatuses.NEW:
                return orderStatuses.NEW_COLOR;
            case orderStatuses.ASSIGNED:
                return orderStatuses.ASSIGNED_COLOR;
            case orderStatuses.IN_PROGRESS:
                return orderStatuses.IN_PROGRESS_COLOR;
            case orderStatuses.COMPLETED:
                return orderStatuses.COMPLETED_COLOR;
            case orderStatuses.CANCELLED:
                return orderStatuses.CANCELLED_COLOR;
            default:
                return 'default';
        }
    },
    getCourierStatusColor(status) {
        switch (status) {
            case courierStatuses.OFF_DUTY:
                return courierStatuses.OFF_DUTY_COLOR;
            case courierStatuses.AVAILABLE:
                return courierStatuses.AVAILABLE_COLOR;
            case courierStatuses.SERVICING:
                return courierStatuses.SERVICING_COLOR;
            default:
                return 'default';
        }
    },
    // Used to sort couriers by status
    compareCouriersByStatus(a, b) {
        const x = courierStatusOrder[a.status];
        const y = courierStatusOrder[b.status];
        if (x < y) return -1;
        if (x > y) return 1;
        return 0;
    }
};
